/* LodyFair scroll-gedrag: één rAF-gedrosselde listener die classes op <body>
   zet. Gebruikt door lodyfair-rhythm.css (WhatsApp-knop verschijnt na 300px)
   en beschikbaar voor toekomstige scroll-styling (lf-scrolled-header, 100px). */
(function () {
  var ticking = false;

  function update() {
    ticking = false;
    var y = window.scrollY || window.pageYOffset;
    var cl = document.body.classList;
    // Hysterese: aan boven 80px, pas weer uit onder 40px — geen geflikker bij licht scrollen
    if (y > 80) {
      cl.add('lf-scrolled-header');
    } else if (y < 40) {
      cl.remove('lf-scrolled-header');
    }
    cl.toggle('lf-scrolled-wa', y > 300);
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    },
    { passive: true }
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
